// deps
import React, { ReactElement, useMemo } from "react";
import { format, isEmpty } from "@swiggy-private/core-ui";

// connstants
import { TEXTS } from "@payment-ui/constants/index";

// test-ids
import { ADD_NEW_CARD_TEST_IDS } from "@swiggy-private/payment-test-ids";
import { CARD_BRAND } from "@payment-ui/constants/Card";

import styles from "../AddNewCard.v4.scss";

interface AddNewCardSaveDetailsProps {
    onInfoClick: (e: React.MouseEvent) => void;
    cardBrand: string;
    tokenizeSupport: boolean;
}

function AddNewCardSaveDetails(props: AddNewCardSaveDetailsProps): ReactElement {
    const title = useMemo(() => {
        if (
            !isEmpty(props.cardBrand) &&
            (props.tokenizeSupport || props.cardBrand.toUpperCase() === CARD_BRAND.SODEXO)
        ) {
            return format(
                "By adding this card, you agree to save it with {0} for seamless future payments. ",
                props.cardBrand,
            );
        }
        return "";
    }, [props.cardBrand, props.tokenizeSupport]);

    return (
        <div className={styles.newCardSaveCardDetails}>
            <div className={styles.newCardSaveCardDetailsText} data-testid={ADD_NEW_CARD_TEST_IDS.SAVE_DETAILS_TEXT}>
                {title}
                {props.tokenizeSupport && (
                    <span className={styles.newCardSaveCardDetailsTextInfo} onClick={props.onInfoClick}>
                        {TEXTS.KNOW_MORE}
                    </span>
                )}
            </div>
        </div>
    );
}

export default React.memo(AddNewCardSaveDetails);
